module.exports = __webpack_public_path__ + "img/9788963722641.d96c97e8.jpg";